import Vue from 'vue';
import axios from 'axios';
import router from "./routes";
import AppComponent from "./components/AppComponent";
import $ from 'jquery';
import VueLazyload from 'vue-lazyload'
import VueScrollTo from 'vue-scrollto';
import {loadProgressBar} from "axios-progress-bar";
import VueMeta from "vue-meta";
import auth from "./auth";
import VueAxios from 'vue-axios';
import VueAuth from '@websanova/vue-auth/dist/v2/vue-auth.common.js';
import store from "./store";
import VueJsModal from 'vue-js-modal'

axios.defaults.baseURL = '/api';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

try {
    Vue.router = router;
} catch (e) {
    console.error(e);
}

try {
    global.$ = global.jQuery = $;
    global.axios = axios;
} catch (e) {
    console.error(e);
}

try {
    Vue.prototype.axios = axios;
    Vue.prototype.$axios = axios;
} catch (e) {
    console.error(e);
}

try {
    window._ = require('lodash');
    window.$ = window.jQuery = $;
    window.axios = axios;
    require('bootstrap');
    require('jquery-ui');
    require('jquery.easing');
    require('@fortawesome/fontawesome-free/js/all');
} catch (e) {
    console.error(e);
}

Vue.use(VueJsModal)
Vue.use(VueAxios, axios);
Vue.use(VueAuth, {
    ...auth,
    plugins: {
        http: Vue.axios,
        router: Vue.router,
    },
});
Vue.use(VueMeta);
Vue.use(VueScrollTo)
Vue.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 2
})

try {
    loadProgressBar();
} catch (e) {
    console.error(e);
}


const app = new Vue({
    store,
    router,
    render: h => h(AppComponent),
});

app.$mount('#app');

export default app;
